<div *ngIf="title" class="title">{{ this.title }}</div>
<mat-button-toggle-group
  [ngClass]="{ 'no-title': !this.title, 'full-width': this.fullWidth }"
  vertical="{{ orientation === 'column' }}"
  [disabled]="disabled"
  [(ngModel)]="value"
>
  <mat-button-toggle
    [disabled]="disabled"
    *ngFor="let item of items"
    [value]="item.value"
  >
    {{ item.text }}
  </mat-button-toggle>
</mat-button-toggle-group>
